import { useEffect, useState } from "react";
import axios from "axios";

const FetchAuthFromServer = () => {
  const [isAuth, setIsAuth] = useState({});  // should default to an object, not an array

  useEffect(() => {
    const getToken = async () => {
      try {
        const response = await axios.get("/api/get-token");
        setIsAuth(response.data);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };

    getToken();
  }, []);

  return isAuth;
}

export default FetchAuthFromServer